// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MiPerfil.module.css */

.MiPerfil_subtitle__-EBmx {
  font-size: 14px;
  color: #667085;
  margin-bottom: 20px;
  margin-top: -12px;
}

/* ── Resumen de perfil ── */
.MiPerfil_profileSummary__T-Gkp {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.MiPerfil_summaryLeft__V253v {
  display: flex;
  align-items: center;
  gap: 16px;
}

.MiPerfil_avatarLg__2V\\+98 {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1a3a5c, #2db899);
  color: #fff;
  font-size: 18px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.MiPerfil_summaryName__QyIDg {
  font-size: 15px;
  font-weight: 800;
  color: #1a3a5c;
  margin-bottom: 2px;
}
.MiPerfil_summaryEmail__dLrym {
  font-size: 12px;
  color: #667085;
  margin-bottom: 8px;
}

.MiPerfil_progressWrap__n2vi5 {
  display: flex;
  align-items: center;
  gap: 10px;
}
.MiPerfil_progressBar__sBXBm {
  width: 120px;
  height: 6px;
  background: #e4e7ec;
  border-radius: 99px;
  overflow: hidden;
}
.MiPerfil_progressFill__-BF1a {
  height: 100%;
  background: #2db899;
  border-radius: 99px;
  transition: width 0.3s;
}
.MiPerfil_progressLabel__DW9cz {
  font-size: 11px;
  color: #2db899;
  font-weight: 700;
}

/* ── Botones top ── */
.MiPerfil_btnEditar__4syYG {
  padding: 9px 20px;
  background: #2db899;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
}
.MiPerfil_btnEditar__4syYG:hover {
  background: #25a085;
}

.MiPerfil_btnCancelarTop__aDdK3 {
  padding: 8px 18px;
  background: transparent;
  color: #d92d20;
  border: 1.5px solid #fda29b;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
}
.MiPerfil_btnCancelarTop__aDdK3:hover {
  background: #fff1f0;
}

/* ── Tabs ── */
.MiPerfil_tabs__YalF3 {
  display: flex;
  gap: 0;
  border-bottom: 2px solid #e4e7ec;
  margin-bottom: 16px;
}

.MiPerfil_tab__k0XrE {
  padding: 10px 20px;
  font-size: 13px;
  font-weight: 600;
  color: #667085;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  cursor: pointer;
  transition:
    color 0.15s,
    border-color 0.15s;
}

.MiPerfil_tab__k0XrE:hover {
  color: #1a3a5c;
}

.MiPerfil_tabActive__r-ccM {
  color: #1a3a5c;
  border-bottom-color: #1a3a5c;
}

/* ── Grid de datos ── */
.MiPerfil_dataGrid__AGrr- {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px 12px;
}

.MiPerfil_fieldGroup__XBVYu {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.MiPerfil_fieldFull__wVyo3 {
  grid-column: 1 / -1;
}

.MiPerfil_fieldLabel__H6Br1 {
  font-size: 10px;
  font-weight: 700;
  color: #98a2b3;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.MiPerfil_fieldValue__Qx-jE {
  font-size: 13px;
  font-weight: 600;
  color: #344054;
  background: #f9fafb;
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  padding: 8px 12px;
  min-height: 36px;
}

/* ── Inputs en modo edición ── */
.MiPerfil_fieldInput__LWcvP {
  font-size: 13px;
  font-weight: 500;
  color: #344054;
  background: #fff;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  padding: 8px 12px;
  outline: none;
  transition: border-color 0.15s;
  width: 100%;
  box-sizing: border-box;
  font-family: inherit;
}

.MiPerfil_fieldInput__LWcvP:focus {
  border-color: #2db899;
}
.MiPerfil_fieldInput__LWcvP:disabled {
  background: #f9fafb;
  color: #98a2b3;
  cursor: not-allowed;
}

/* ── Acciones de edición ── */
.MiPerfil_editActions__toBha {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f2f4f7;
}

.MiPerfil_btnCancelarBottom__Gmbkw {
  padding: 10px 22px;
  background: transparent;
  color: #667085;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.MiPerfil_btnCancelarBottom__Gmbkw:hover {
  background: #f2f4f7;
}

.MiPerfil_btnGuardar__4MT1P {
  padding: 10px 24px;
  background: #2db899;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;
}
.MiPerfil_btnGuardar__4MT1P:hover {
  background: #25a085;
}
.MiPerfil_btnGuardar__4MT1P:disabled {
  background: #b0e0d8;
  cursor: not-allowed;
}

/* ── Responsive ── */
@media (max-width: 1100px) {
  .MiPerfil_dataGrid__AGrr- {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 720px) {
  .MiPerfil_dataGrid__AGrr- {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 500px) {
  .MiPerfil_dataGrid__AGrr- {
    grid-template-columns: 1fr;
  }
  .MiPerfil_profileSummary__T-Gkp {
    flex-direction: column;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DetailsUser/MiPerfil.module.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,MAAM;EACN,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf;;sBAEoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":["/* MiPerfil.module.css */\n\n.subtitle {\n  font-size: 14px;\n  color: #667085;\n  margin-bottom: 20px;\n  margin-top: -12px;\n}\n\n/* ── Resumen de perfil ── */\n.profileSummary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.summaryLeft {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.avatarLg {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #1a3a5c, #2db899);\n  color: #fff;\n  font-size: 18px;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.summaryName {\n  font-size: 15px;\n  font-weight: 800;\n  color: #1a3a5c;\n  margin-bottom: 2px;\n}\n.summaryEmail {\n  font-size: 12px;\n  color: #667085;\n  margin-bottom: 8px;\n}\n\n.progressWrap {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.progressBar {\n  width: 120px;\n  height: 6px;\n  background: #e4e7ec;\n  border-radius: 99px;\n  overflow: hidden;\n}\n.progressFill {\n  height: 100%;\n  background: #2db899;\n  border-radius: 99px;\n  transition: width 0.3s;\n}\n.progressLabel {\n  font-size: 11px;\n  color: #2db899;\n  font-weight: 700;\n}\n\n/* ── Botones top ── */\n.btnEditar {\n  padding: 9px 20px;\n  background: #2db899;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.2s;\n  white-space: nowrap;\n}\n.btnEditar:hover {\n  background: #25a085;\n}\n\n.btnCancelarTop {\n  padding: 8px 18px;\n  background: transparent;\n  color: #d92d20;\n  border: 1.5px solid #fda29b;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n  white-space: nowrap;\n}\n.btnCancelarTop:hover {\n  background: #fff1f0;\n}\n\n/* ── Tabs ── */\n.tabs {\n  display: flex;\n  gap: 0;\n  border-bottom: 2px solid #e4e7ec;\n  margin-bottom: 16px;\n}\n\n.tab {\n  padding: 10px 20px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #667085;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  cursor: pointer;\n  transition:\n    color 0.15s,\n    border-color 0.15s;\n}\n\n.tab:hover {\n  color: #1a3a5c;\n}\n\n.tabActive {\n  color: #1a3a5c;\n  border-bottom-color: #1a3a5c;\n}\n\n/* ── Grid de datos ── */\n.dataGrid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 16px 12px;\n}\n\n.fieldGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.fieldFull {\n  grid-column: 1 / -1;\n}\n\n.fieldLabel {\n  font-size: 10px;\n  font-weight: 700;\n  color: #98a2b3;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n}\n\n.fieldValue {\n  font-size: 13px;\n  font-weight: 600;\n  color: #344054;\n  background: #f9fafb;\n  border: 1px solid #e4e7ec;\n  border-radius: 8px;\n  padding: 8px 12px;\n  min-height: 36px;\n}\n\n/* ── Inputs en modo edición ── */\n.fieldInput {\n  font-size: 13px;\n  font-weight: 500;\n  color: #344054;\n  background: #fff;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  padding: 8px 12px;\n  outline: none;\n  transition: border-color 0.15s;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: inherit;\n}\n\n.fieldInput:focus {\n  border-color: #2db899;\n}\n.fieldInput:disabled {\n  background: #f9fafb;\n  color: #98a2b3;\n  cursor: not-allowed;\n}\n\n/* ── Acciones de edición ── */\n.editActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid #f2f4f7;\n}\n\n.btnCancelarBottom {\n  padding: 10px 22px;\n  background: transparent;\n  color: #667085;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.btnCancelarBottom:hover {\n  background: #f2f4f7;\n}\n\n.btnGuardar {\n  padding: 10px 24px;\n  background: #2db899;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.btnGuardar:hover {\n  background: #25a085;\n}\n.btnGuardar:disabled {\n  background: #b0e0d8;\n  cursor: not-allowed;\n}\n\n/* ── Responsive ── */\n@media (max-width: 1100px) {\n  .dataGrid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n@media (max-width: 720px) {\n  .dataGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media (max-width: 500px) {\n  .dataGrid {\n    grid-template-columns: 1fr;\n  }\n  .profileSummary {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subtitle": `MiPerfil_subtitle__-EBmx`,
	"profileSummary": `MiPerfil_profileSummary__T-Gkp`,
	"summaryLeft": `MiPerfil_summaryLeft__V253v`,
	"avatarLg": `MiPerfil_avatarLg__2V+98`,
	"summaryName": `MiPerfil_summaryName__QyIDg`,
	"summaryEmail": `MiPerfil_summaryEmail__dLrym`,
	"progressWrap": `MiPerfil_progressWrap__n2vi5`,
	"progressBar": `MiPerfil_progressBar__sBXBm`,
	"progressFill": `MiPerfil_progressFill__-BF1a`,
	"progressLabel": `MiPerfil_progressLabel__DW9cz`,
	"btnEditar": `MiPerfil_btnEditar__4syYG`,
	"btnCancelarTop": `MiPerfil_btnCancelarTop__aDdK3`,
	"tabs": `MiPerfil_tabs__YalF3`,
	"tab": `MiPerfil_tab__k0XrE`,
	"tabActive": `MiPerfil_tabActive__r-ccM`,
	"dataGrid": `MiPerfil_dataGrid__AGrr-`,
	"fieldGroup": `MiPerfil_fieldGroup__XBVYu`,
	"fieldFull": `MiPerfil_fieldFull__wVyo3`,
	"fieldLabel": `MiPerfil_fieldLabel__H6Br1`,
	"fieldValue": `MiPerfil_fieldValue__Qx-jE`,
	"fieldInput": `MiPerfil_fieldInput__LWcvP`,
	"editActions": `MiPerfil_editActions__toBha`,
	"btnCancelarBottom": `MiPerfil_btnCancelarBottom__Gmbkw`,
	"btnGuardar": `MiPerfil_btnGuardar__4MT1P`
};
export default ___CSS_LOADER_EXPORT___;
